import cx from 'classnames'
import { observer } from 'mobx-react-lite'

import { ReactComponent as UnderlineIcon } from 'assets/icons/underline24.svg'
import { useUnderlineToggle } from 'common/Prose/Toolbar/hooks/useUnderlineToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

import Styles from '../../MobileToolbar.module.scss'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'

export const UnderlineMark = observer((props: ButtonProps) => {
  const view = useEditorView()
  const { active, disabled, handleClick } = useUnderlineToggle(view)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Set underline"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: active,
        [Styles.disabled]: disabled,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-underline-mark"
      {...props}
    >
      <UnderlineIcon />
    </Button>
  )
})
